export default __webpack_public_path__ + "static/media/e8.d002786a.jpg";